import axios, { AxiosResponse } from 'axios';

import { EAuthPrvek } from './prehled';

export interface IUzivatelDetail {
    id: number;
    jmeno: string;
    prijmeni: string;
    telefon: string;
    email: string;
    typprihlaseni: EAuthPrvek;
    pristup: boolean;
    stavuctu: EStavUzivatele;
    username: string;
    dn: string;
    issuer: string;
    tempcert: string;
    vypis: boolean;
    upis: boolean;
    sicav: boolean;
    srd: boolean;
    videtvypisyost: boolean;
    adminuziv: boolean;
}

export enum EStavUzivatele {
    AKTIVNI = 'AKTIVNI', // aktivní,
    NEAKTIVNI = 'NEAKTIVNI' // neaktivní
}

export interface ICertKontrolaResp {
    message: string;
    pouziticert: IPouzityCert[];
    dn: string;
    issuer: string;
    serial: string;
}
export interface IPouzityCert {
    uzivatel: string;
    profil: string;
    idsubjektu: number;
    subjekt: string;
}

const detailUzivateleApi = (id: number) => {
    return axios({
        method: 'GET',
        url: `/UzivEmit/${id}/Detail`
    }).then((resp: AxiosResponse<IUzivatelDetail>) => resp.data);
};

export const certKontrolaApi = (tempnazev: string) => {
    return axios({
        method: 'GET',
        url: 'Portal/Certifikat/Kontrola',
        params: {
            tempnazev: tempnazev
        }
    }).then((resp: AxiosResponse<ICertKontrolaResp>) => resp.data);
};

export const uzivatelEditApi = (data: IUzivatelDetail) => {
    return axios({
        method: 'POST',
        url: '/UzivEmit/Zalozeni',
        data: data
    });
};

export const deleteUzivatelApi = (id: number) => {
    return axios({
        method: 'DELETE',
        url: `/UzivEmit/${id}/Zruseni`
    });
};

export default detailUzivateleApi;
